import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {ProjectService} from '@catcore/services';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class CurrentProjectResolve implements Resolve<any> {
  constructor(protected projectService: ProjectService,
              protected router: Router,
              ) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this.projectService.getCurrentProject()
      .map((project) => project)
      .first();

  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/resolve/current-project.resolve.ts